import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../../Global/nota.guidelines.json";

import NanoFlex from "../../../Global/NanoFlex.js";
import InternationalFlowsTable from "../../../Micro/InternationalFlowsTable.js";
import WrapperList from "../../../Nano/WrapperList.js";
import TitleCard from "../../../Nano/TitleCard.js";

//Images
import iconAirplane from "../../../Global/Icons/airplane.svg";

const StyledInternationalFlowBlock = styled(NanoFlex)``;

export class InternationalFlowBlock extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    if (!this.props.internationalFlow || this.props.internationalFlow.length <= 1) return null;

    return (
      <StyledInternationalFlowBlock className="rowContainer internationalFlowBlock">
        <WrapperList simple className="marginWrapper internationalFlow">
          <TitleCard simpleTitle={this.translation.card.internationalFlow} icon={iconAirplane} />
          <InternationalFlowsTable data={this.props.internationalFlow} selected={this.props.selected} />
        </WrapperList>
      </StyledInternationalFlowBlock>
    );
  }
}

//Set default props
InternationalFlowBlock.defaultProps = {
  card: {},
};

export default InternationalFlowBlock;

// --- // Documentation // --- //
/*
  import InternationalFlowBlock from './../Partial/InternationalFlowBlock.js';
  
  <InternationalFlowBlock/>
  */
